import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { FirebaseProvider } from "./firebase";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { icons } from "./assets/icons";
import { SearchProvider } from "./provider/searchProvider";
import { SnackbarProvider } from "notistack";
import { CookiesProvider } from "react-cookie";
let persistor = persistStore(store);

// @ts-ignore
React.icons = icons;

ReactDOM.render(
  <React.StrictMode>
    <SearchProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <FirebaseProvider>
            <SnackbarProvider>
              <CookiesProvider>
                <App />
              </CookiesProvider>
            </SnackbarProvider>
          </FirebaseProvider>
        </PersistGate>
      </Provider>
    </SearchProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
